import {InjectionToken} from '@angular/core';
import { HttpClient } from '@angular/common/http';

export const HTTP_CLIENT_WITH_ERROR_HANDLING = new InjectionToken<HttpClient>('HttpClientWithErrorHandling');
